import { devConfig } from "@/api/apiAuth";

export const fetchUrl = async (url, kind, isUpdate = false) => {
  const baseUrl = devConfig.baseUrl;
  try {
    const params = new URLSearchParams({
      ticker: kind,
      limit: isUpdate ? 1 : 0,
    });

    const response = await fetch(`${baseUrl}${url}?${params}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    return data.result;
  } catch (error) {
    // const totalUrl = `Current host url:${currentPathname}\n Request url:${url}`;
    console.error("API Error:", error);
    // sendTelegram(totalUrl, { ticker: kind, limit: isUpdate ? 1 : 0 }, error);
    throw error;
  }
};

export const fetchUrlWithLimit = async (url, kind, limit = 0) => {
  const baseUrl = devConfig.baseUrl;
  try {
    const params = new URLSearchParams({
      ticker: kind,
      limit: limit,
    });

    const response = await fetch(`${baseUrl}${url}?${params}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
